import { ComponentPropsWithoutRef, ReactNode, useEffect, useState } from 'react';
import classNames from 'classnames';

interface MenuProps extends ComponentPropsWithoutRef<'div'> {
  children: ReactNode;
  toggler?: ReactNode;
  open?: boolean;
}

export function Collapse({ children, toggler, className, open = false, ...rest }: MenuProps) {
  const [menuOpen, setMenuOpen] = useState(open);

  useEffect(() => {
    setMenuOpen(open);
  }, [open]);

  return (
    <div
      className={classNames(
        'grid grid-rows-[max-content_0fr] overflow-clip transition-all',
        {'grid-rows-[max-content_1fr] collapse-open': menuOpen },
        className
      )}
      {...rest}
    >
      {toggler ? (<div className="row-start-1 col-start-1 cursor-pointer justify-self-start" onClick={() => setMenuOpen(!menuOpen)}>
        {toggler}
      </div>) : <div />}
      <div className={classNames(
        'min-h-min flex flex-col',
        'opacity-0 transition-all',
        { 'opacity-100': menuOpen },
      )}>
        {children}
      </div>
    </div>
  );
}
